import { Outlet, useOutletContext } from "react-router-dom"
import { CompanyPaymentsSettingsProvider } from "../contexts/CompanyPaymentsSettingsContext"
import { PropsWithChildren } from "react"

export const WithCompanyPaymentsSettingsRoute = ({ children }: PropsWithChildren<unknown>) => {
  const parentContext = useOutletContext()

  return (
    <CompanyPaymentsSettingsProvider>
      {children ? <>{children}</> : <Outlet context={parentContext} />}
    </CompanyPaymentsSettingsProvider>
  )
}
